
export const RECAPTCHA_SITE_KEY = "6LfZHGUrAAAAALvAACRghdiTSXqT6Fm25bjeEQ2L";
